export const normalizePrice = (msrp, price) => {
    const result = price > 0 ? price : msrp;
    return result < 0 ? 0 : result;
};

export const getDistinctValues = (group, key) => {
    const distinctList = [];
    const { length } = group;
    for (let i = 0; i < length; i += 1) {
        const value = group[i][key];
        if (distinctList.indexOf(value) === -1) {
            distinctList.push(value);
        }
    }
    return distinctList;
};

/* eslint-disable */
export const formatPrice = (value) => {
    return '$' + value.toFixed(0).replace(/./g, (c, i, a) => {
        return i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c;
    });
};
/* eslint-enable */

/* eslint-disable */
export const formatNumber = value => {
    return value.toFixed(0).replace(/./g, (c, i, a) => {
        return i && c !== '.' && ((a.length - i) % 3 === 0) ? ',' + c : c;
    });
};
/* eslint-enable */

export const urlEncode = str => str.replace(/\s/g, '+');

export const urlDecode = str => str.replace(/[+]+/g, ' ');
